module.exports = __webpack_public_path__ + "img/blog-5.2d2ba900.webp";